<template>
<div
    v-if="content"
    @click="goToCertificate"
    :class="{pointer: content.progress === 100}"
    :data-progress="content.progress"
    class="progress-circle"
>
    <i class="mdi mdi-trophy certificate__trophy"/>
    <div>
        <div class="full progress-circle__slice">
            <div class="progress-circle__fill" :style="style"/>
        </div>
    </div>
    <div class="progress-circle__slice">
        <div class="progress-circle__fill" :style="style"/>
        <div class="progress-circle__fill progress-circle__bar" :style="style"/>
    </div>
    <div class="progress-circle__overlay"/>
    <span> {{ content.progress }}% </span>
</div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    name: 'ClassTopbarCertificate',
    computed: {
        ...mapGetters({
            color: 'COLOR',
            content: 'CLASS_CONTENT_ITEM',
        }),
        style() {
            return `background-color: ${this.color.secondary}`;
        },
    },
    methods: {
        goToCertificate() {
            const currentProgress = this.content.progress;
            const certificateProgress = this.content.certificateProgress;
            const generateCertificate = currentProgress >= certificateProgress;
            if (!generateCertificate) {
                return this.$notify({
                    type: 'warning',
                    message: this.$t('class.certificate_without_progress'),
                });
            }
            window.location = `/app/certificate/show/exercise/${this.content.id}`;
        },
    },
};
</script>

<style lang="scss" scoped>
@use "sass:math";
$circle-size: 48px;
$circle-background: #2b2b29;
$inset-size: 40px;
$inset-color: #dedede;
$transition-length: .6s;
.certificate__trophy {
    z-index: 999;
    top: 50%;
    font-size: 24px;
    left: 50%;
    transform: translate(-50%,-50%);
    position: absolute;
    opacity: 1;
    transition: all .3s ease;
    color: $circle-background;
}
span {
    font-size: 16px;
    font-weight: bolder;
    position: absolute;
    transform: translate(-50%,-50%);
    top: 54%;
    left: 50%;
    opacity: 0;
    transition: all .3s ease;
    color: $circle-background;
}

.progress-circle__overlay {
    width:       $inset-size;
    height:      $inset-size;
    position:    absolute;
    margin-left: math.div($circle-size - $inset-size, 2);
    margin-top:  math.div($circle-size - $inset-size, 2);
    background-color: $inset-color;
    border-radius: 50%;
    box-shadow: 0px 0px 6px rgba(0,0,0,.5) inset;

}

.progress-circle {
    width:  $circle-size;
    height: $circle-size;
    background-color: $circle-background;
    border-radius: 50%;
    position: relative;
    box-shadow: 0px 0px 8px rgba(0,0,0,.5);

    &:hover {
        .certificate__trophy{ opacity: 0 }
        span { opacity: 1 }
    }

    &.pointer {
        cursor: pointer;
    }

    .progress-circle__slice, .progress-circle__fill {
        width:    $circle-size;
        height:   $circle-size;
        position: absolute;
        -webkit-backface-visibility: hidden;
        transition: transform $transition-length;
        border-radius: 50%;
    }
    .progress-circle__slice {
        clip: rect(0px, $circle-size, $circle-size, math.div($circle-size, 2));
        .progress-circle__fill {
            clip: rect(0px, math.div($circle-size, 2), $circle-size, 0px);
        }
    }

    $i: 0;
    $increment: math.div(180deg, 100);
    @while $i <= 100 {
        &[data-progress='#{$i}'] {
            .progress-circle__slice.full, .progress-circle__fill {
                transform: rotate($increment * $i);
            }
            .progress-circle__fill.progress-circle__bar {
                transform: rotate($increment * $i * 2);
            }
        $i: $i + 1;
        }
    }
}
</style>
